import { useState, useCallback } from "react";
import axios from "axios";
import { OPENAI_API_KEY } from "../../../Constatns";
const useChatCompletion = () => {
  const [isFetching, setIsFetching] = useState(false);
  const [error, setError] = useState(null);

  const fetchResponse = useCallback(async (conversationHistory, tools) => {
    if (!conversationHistory || !Array.isArray(conversationHistory) || conversationHistory.length === 0) {
      console.error("Invalid messages array");
      return null;
    }
    setIsFetching(true);
    setError(null);
    try {
      const response = await axios.post(
        "https://api.openai.com/v1/chat/completions",
        {
          model: "gpt-4o",
          messages: conversationHistory,
          tools,
          response_format: {
            type: "json_object",
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${OPENAI_API_KEY}`,
          },
        }
      );
      return response;
    } catch (err) {
      console.error("Error fetching requirement:", err);
      let apiErrorMessage = "An unknown error occurred.";

      if (err.response) {
        // If response exists, extract the error message
        apiErrorMessage = err.response.data?.error?.message || apiErrorMessage;
      } else if (err.request) {
        // If request was made but no response was received
        apiErrorMessage = "No response from server. Please try again later.";
      } else {
        // If something else caused the error
        apiErrorMessage = err.message;
      }
      setError(err?.message || "Error occured. Please try again.");
      return {errorMessage: "Error occured. Please try again."};
    } finally {
      setIsFetching(false);
    }
  }, []);

  return { isFetching, error, fetchResponse };
};

export default useChatCompletion;
